// flow weak

import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert,
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";

import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";

import "../dashboard/dashboard.scss";
import { printVoucher } from "../../../redux/actions/frontActions";
import { voucherStatus } from "../../../redux/actions/frontActions";

import logo from "../../../img/ddb-logo.png";

import { appConfig } from "../../../config";

import { Notification } from "../../../components/notifications";

import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";

import ReactHtmlParser from "react-html-parser";
import Cookies from "universal-cookie";


const cookies = new Cookies();

import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
const history = createBrowserHistory();
let isLoading = "false";
class Voucher extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      show: false,
      voucher: "",
      hover: false,
      check:0,
       default_lang: cookies.get("default_lang")
        ? cookies.get("default_lang")
        : "en",
    };

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
  }

  hoverOn = (e) => {
    if (e.target.attributes.getNamedItem("data-id").value) {
      this.setState({
        hover: true,
        hoverID: e.target.attributes.getNamedItem("data-id").value,
      });
    }
  };

  hoverOff = (e) => {
    if (e.target.attributes.getNamedItem("data-id").value) {
      this.setState({
        hover: false,
        hoverID: e.target.attributes.getNamedItem("data-id").value,
      });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  Clear() {
    this.setState({
      show: false,
    });
  }

  handlePageChange = (lang = "en") => {
    let voucherIDParams = this.props.route.match.params.voucherID
      ? this.props.route.match.params.voucherID
      : "";
    let type = this.props.route.match.params.type
      ? this.props.route.match.params.type
      : "paid";
    if (voucherIDParams !== "") {
      isLoading = "true";
     // this.setState({check: 0});
      this.props.printVoucher(voucherIDParams, type, lang);
    }
  };

  onVoucherRedeem = (voucherNumber) => {
    this.props.voucherStatus({
      voucherNumber: voucherNumber,
      lang: this.state.default_lang,
      redeemedBy: "Customer",
    });
  };

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    this.handlePageChange(cookies.get('default_lang'));
    if (this.props.themeData) {
      if (this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.themeData) {
      if (nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }

     if (nextProps.language) {
 
      if (this.state.default_lang !== nextProps.language ) {
             this.setState({default_lang: nextProps.language });
    
        this.handlePageChange(cookies.get('default_lang'));
      }
    }

    if (this.props.voucherDetail !== nextProps.voucherDetail) {
      if (nextProps.voucherDetail) {
        if (nextProps.voucherDetail.error) {
          window.alert(nextProps.voucherDetail.error);
          if (nextProps.voucherDetail.error == "Login required") {
            this.context.router.history.push("/login");
          } else {
            this.context.router.history.push("/");
          }
        } else {
          isLoading = "false";
          this.setState({ voucher: nextProps.voucherDetail });
          this.setState({
            voucher111: nextProps.voucherDetail.data.voucherNumber,
          });
        }
      }
    }

    if (this.props.orderRedeem != nextProps.orderRedeem) {
      if (nextProps.orderRedeem) {
        this.setState({ showAlert: true });
        this.handleShow();
        this.props.renderAlert("success", nextProps.orderRedeem.message);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.error != nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }
  }

  componentWillUpdate(nextProps, nextState) {}

  printDiv = () => {
    let divToPrint = document.getElementById("DivIdToPrint");

    let newWin = window.open("", "Print-Window");

    newWin.document.open();

    newWin.document.write(
      '<html><body onload="window.print()">' +
        divToPrint.innerHTML +
        "</body></html>"
    );

    newWin.document.close();
  };

  render() {
    const style = {
      width: "100%",
      height: "100%",
    };

    var points = [
      { lat: 42.02, lng: -77.01 },
      { lat: 42.03, lng: -77.02 },
      { lat: 41.03, lng: -77.04 },
      { lat: 42.05, lng: -77.02 },
    ];
    var bounds = new this.props.google.maps.LatLngBounds();
    for (var i = 0; i < points.length; i++) {
      bounds.extend(points[i]);
    }

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.show && this.state.alertMessage !== "" && (
          <div
            className="container"
            style={{ marginTop: -13, marginBottom: -41 }}
          >
            <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
              <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
            </Alert>
          </div>
        )}
        <div className="container">
          <div className="panel voucher-detail margin-top">
            <header className="panel-heading">
              <span>Voucher Detail </span>

              <Button
                onClick={() =>
                  this.onVoucherRedeem(this.state.voucher.data.voucherNumber)
                }
                bsSize="small"
                className="pull-right"
                style={{
                  backgroundColor:
                    this.state.hover && this.state.hoverID == "order1"
                      ? this.state.mouseover_color
                      : this.state.button_color
                      ? this.state.button_color
                      : "#77C84E",
                  height: 31,
                }}
                onMouseEnter={this.hoverOn}
                onMouseLeave={this.hoverOff}
                bsStyle="success"
                data-id="order1"
              >
                <i className="glyphicon glyphicon-check" /> Mark as Used
              </Button>
              {this.state.voucher.data &&
              this.state.voucher.data.showRedeemLink &&
              this.state.voucher.data.redemptionUrl &&
              this.state.voucher.data.redemptionUrl !== "null" ? (
                <a
                  href={`${this.state.voucher.data.redemptionUrl}`}
                  bsSize="small"
                  className="pull-right btn btn-sm btn-success"
                  target="_blank"
                  style={{
                    backgroundColor:
                      this.state.hover && this.state.hoverID == "order"
                        ? this.state.mouseover_color
                        : this.state.button_color
                        ? this.state.button_color
                        : "#77C84E",
                    height: 31,
                  }}
                  data-id="order"
                  onMouseEnter={this.hoverOn}
                  onMouseLeave={this.hoverOff}
                  bsStyle="success"
                >
                  <i className="glyphicon glyphicon-link" /> Redemption Link
                </a>
              ) : (
                <Button
                  bsSize="small"
                  className="pull-right"
                  style={{
                    backgroundColor:
                      this.state.hover && this.state.hoverID == "order"
                        ? this.state.mouseover_color
                        : this.state.button_color
                        ? this.state.button_color
                        : "#77C84E",
                    height: 31,
                  }}
                  data-id="order"
                  onMouseEnter={this.hoverOn}
                  onMouseLeave={this.hoverOff}
                  bsStyle="success"
                  type="submit"
                  onClick={this.printDiv.bind(this)}
                >
                  <i className="glyphicon glyphicon-print" /> Print
                </Button>
              )}
            </header>
            <div className="panel-body" id="DivIdToPrint">
              {!isEmpty(this.state.voucher) ? (
                <Row>
                  <Col md={12} xs={12}>
                    {!isEmpty(this.state.voucher.template)
                      ? ReactHtmlParser(this.state.voucher.template)
                      : ""}
                  </Col>
                </Row>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Voucher.propTypes = {
  printVoucher: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  error: state.frontReducer.error,
  voucherDetail: state.frontReducer.voucherDetail,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  orderRedeem: state.frontReducer.ordertracking,
});

export default compose(
  GoogleApiWrapper((props) => ({
    apiKey: props.mapkey ? props.mapkey : "",
  })),
  connect(
    mapStateToProps,
    { printVoucher, voucherStatus, renderAlert, clearAlert },
    null,
    { pure: false }
  )
)(Voucher);



// WEBPACK FOOTER //
// ./src/app/views/frontend/user/Voucher.js